import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import PowerFooter from '../../components/power-footer';
import './index.less';

const LoginAccountDetails = () => {
    const { t } = useTranslation();
    const unlinkAccount = () => {};

    return (
        <div className="login-account-details">
            <div className="account-title">Title</div>
            <div className="account-value">chuanfa.chai@gmail.com</div>
            <div className="unlink-account-hint">{t('account.unlink_hint')}</div>
            <Button className="primary-antd-btn btn-unlink" onClick={unlinkAccount}>
                {t('account.unlink')}
            </Button>
            <PowerFooter />
        </div>
    );
};

export default LoginAccountDetails;
